module.exports = __webpack_public_path__ + "img/image_12.00f8ad42.jpg";